export const employeeStatus = {
    probation: 1,
    active: 3,
    resigned: 9
};

export const employeeStatusMappings = [
    {
        key: employeeStatus?.probation,
        displayLabel: {
            en: 'Probationary Employee',
            th: 'พนักงานทดลองงาน'
        },
        colorHex: '#EBAF81'
    },
    {
        key: employeeStatus?.active,
        displayLabel: {
            en: 'Permanent Employee',
            th: 'พนักงาน'
        },
        colorHex: '#7FB414'
    },
    {
        key: employeeStatus?.resigned,
        displayLabel: {
            en: 'Resigned Employee',
            th: 'พ้นสภาพพนักงาน'
        },
        colorHex: '#F65C78'
    }
]
